import React from 'react'
import { CaptionText, BodyText, Row, Button } from '@paypalcorp/pp-react'
import PropTypes from 'prop-types'
import './index.css'
import { getLocalizedText } from 'ppbl/utils/locale-helper'

const ReadOnlyCard = ({ id, fieldsList, isEditable, handleButtonClick, cardClassName }) => {
  return (
    <div className={`card ${cardClassName ? cardClassName : ''}`} id={id}>
      <div className="card_texts" data-dd-privacy="mask">
        {Object.keys(fieldsList).map((key, index) => (
          <div key={index}>
            <Row>
              <CaptionText className="card_caption_text texts">
                {key}
              </CaptionText>
            </Row>
            <Row>
              <BodyText className="texts">{fieldsList[key]}</BodyText>
            </Row>
          </div>
        ))}
      </div>
      {isEditable && <div>
        <Button onClick={handleButtonClick} tertiary>
          {getLocalizedText('components.addressCard.changeBtn')}
        </Button>
      </div>}
    </div>
  )
}

ReadOnlyCard.propTypes = {
  id: PropTypes.string,
  fieldsList: PropTypes.object,
  isEditable: PropTypes.bool,
  handleButtonClick: PropTypes.func,
  cardClassName: PropTypes.string,
}

export default ReadOnlyCard
